export default function Loader() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black">
      <video
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/logo.webm" type="video/webm" />
      </video>
    </div>
  );
}